import { DASHBOARD_API_ENDPOINTS } from "../config/api/apiCallDashboard";
import { callApi } from "../utils/apiClient";

export const loadProductionSummaryDashboard = async (fromdate,todate) => {
    try {
        // localStorage.getItem('companyid') || 0,
        const payload = {

            p_company_id: localStorage.getItem('companyid') || 0,            
            p_plant_id: 1,
            p_from_date:fromdate,
            p_to_date:todate,
        };

        return await callApi(DASHBOARD_API_ENDPOINTS.dashboard.production_summary, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading warehouse type list:", error);
        throw error;
    }
};

export const loadProductionReelWiseSummaryDashboard = async (fromdate,todate) => {
    try {
        // localStorage.getItem('companyid') || 0,
        const payload = {

            p_company_id: localStorage.getItem('companyid') || 0,            
            p_plant_id: 1,
            p_from_date:fromdate,
            p_to_date:todate,
        };

        return await callApi(DASHBOARD_API_ENDPOINTS.dashboard.production_summary_grade_wise_reel, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading warehouse type list:", error);
        throw error;
    }
};